import { Box, Stack } from "@mui/joy";
import { ThoughtmapDownArrow } from "./ThoughtMap";
import ThoughtMapCard from "./ThoughtMapCard";
import { ThoughtMapText } from "./ThoughtMapText";
import {
  getTaskIdFromTaskKey,
  getTaskTitleFromTaskId,
} from "../../logic/logics";
import { ThoughtMapTaskItem } from "./AutomaticThoughtByThoughtTrap";

export default function BeliefTemplete({
  title,
  data,
  placeholder,
  hasConnectionLine,
  taskKey,
}: {
  title: string;
  data: { label: string; value: string }[];
  placeholder: string;
  hasConnectionLine?: boolean;
  taskKey?: string;
}) {
  return (
    <>
      {hasConnectionLine && <ThoughtmapDownArrow />}
      <ThoughtMapCard
        label={title}
        content={
          data && data.length > 0 ? (
            <Stack spacing={1}>
              {data.map(({ label, value }, index) => (
                <Stack key={`${label}`} spacing={"8px"}>
                  <ThoughtMapText text={label} dimmed color="primary.solid" />
                  <ThoughtMapText text={value} />
                </Stack>
              ))}
              {taskKey && (
                <ThoughtMapTaskItem
                  key={`thoughtTrap_${taskKey}`}
                  text={getTaskTitleFromTaskId(getTaskIdFromTaskKey(taskKey))}
                  taskKey={taskKey}
                />
              )}
            </Stack>
          ) : (
            <ThoughtMapText text={placeholder} dimmed />
          )
        }
        dimmed={data.length === 0}
      />
    </>
  );
}
